import { HistoryButtonProps } from "./history-button.props";
import { Button as MuiButton, IconButton } from "@material-ui/core";
import HistoryIcon from "@material-ui/icons/History";

export const HistoryButton = (props: HistoryButtonProps) => {
  if ((props.useIcon && props.useIconOnly) || (props.useIcon && props.text === "")) {
    return (
      <IconButton
        className={props.className}
        onClick={props.onClick}
        size={props.buttonSize}
        title={props.text}
      >
        <HistoryIcon />
      </IconButton>
    );
  }

  const Component = !!props.customComponent ? props.customComponent : MuiButton;
  const startIcon = props.useIcon ? <HistoryIcon /> : null;

  return (
    <Component
      className={props.className}
      onClick={props.onClick}
      startIcon={startIcon}
      size={props.buttonSize}
    >
      {props.text}
    </Component>
  );
};
